import { color } from "echarts";
import styled from "styled-components";

export const StyledChatbotPopup = styled.div`
  position: fixed;
  width: 40rem;
  height: 50rem;

  min-width: 20rem;
  max-width: 80rem;
  min-height: 20rem;
  max-height: 80rem;

  background-color: var(--bg-gray-0);
  border-radius: 0.8rem;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 10000;
  display: flex;
  flex-direction: column;

  transform: translate(-50%, -50%);

  .top-handle,
  .left-handle,
  .right-handle,
  .bottom-handle,
  .top-left-handle,
  .top-right-handle,
  .bottom-left-handle,
  .bottom-right-handle {
    position: absolute;

    &.top-handle {
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      cursor: ns-resize;
    }

    &.left-handle {
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      height: 100%;
      width: 2px;
      cursor: ew-resize;
    }

    &.right-handle {
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      height: 100%;
      width: 2px;
      cursor: ew-resize;
    }

    &.bottom-handle {
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      cursor: ns-resize;
    }

    &.top-left-handle {
      top: 0;
      left: 0;
      width: 4px;
      height: 4px;
      cursor: nwse-resize;
    }

    &.top-right-handle {
      top: 0;
      right: 0;
      width: 4px;
      height: 4px;
      cursor: nesw-resize;
    }

    &.bottom-left-handle {
      bottom: 0;
      left: 0;
      width: 4px;
      height: 4px;
      cursor: nesw-resize;
    }

    &.bottom-right-handle {
      bottom: 0;
      right: 0;
      width: 4px;
      height: 4px;
      cursor: nwse-resize;
    }
  }

  header {
    width: 100%;
    box-sizing: border-box;
    height: 4rem;
    background-color: var(--bg-gray-5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.6rem;
    &:hover {
      cursor: move;
    }
    h1 {
      font: var(--body-medium-600);
      color: var(--text-gray-normal);
      display: flex;
      align-items: center;
      gap: 0.8rem;
    }
  }
`;
